export default __webpack_public_path__ + "static/media/blueeyes7.93b88a5e.jpg";